module.exports = __webpack_public_path__ + "static/media/이대명.c7a46686.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person/이대명.png
// module id = 98
// module chunks = 0